<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="1">
                <v-select
                    v-model="localInvoiceType"
                    :items="invoiceTypes"
                    label="Invoice Type"
                    item-text="name"
                    return-object
                    class="ml-1"
                    prepend-inner-icon="mdi-file-chart"
                    @change="emitInvoiceType"
                >
                    <template v-slot:item="{ item }">
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                            v-text="item.name"
                        ></v-list-item-title>
                    </template>
                </v-select>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" md="2">
                <v-select
                    v-model="search.filterBy"
                    :items="search.items"
                    label="Search By"
                    prepend-inner-icon="mdi-filter"
                ></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    v-model="search.input"
                    label="Search"
                    prepend-inner-icon="mdi-magnify"
                >
                </v-text-field>
            </v-col>
            <v-col cols="12" md="1" align-self="center">
                <v-btn color="primary" @click="emitSearch">
                    <v-icon left>mdi-magnify</v-icon>
                    Search
                </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-divider vertical></v-divider>
            <v-col cols="12" md="2">
                <v-select
                    v-model="sort.sortBy"
                    :items="sort.items"
                    label="Sort By"
                    prepend-inner-icon="mdi-sort"
                >
                    <template v-slot:append-outer>
                        <v-btn
                            v-model="sort.sortDesc"
                            icon
                            @click="toggleSortDirection"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">{{
                                        sort.sortDesc === true
                                            ? 'mdi-sort-calendar-ascending'
                                            : 'mdi-sort-calendar-descending'
                                    }}</v-icon>
                                </template>
                                <span>Switch the date sorting order: </span>
                                <span v-if="sort.sortDesc === true"
                                    >Descending</span
                                >
                                <span v-else>Ascending</span>
                            </v-tooltip>
                        </v-btn>
                    </template>
                </v-select>
            </v-col>
            <!-- TODO: Add more filters -->
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'InvoiceFilters',
    props: {
        invoiceTypes: Array,
        invoiceType: Object
    },
    data() {
        return {
            localInvoiceType: this.invoiceType,
            sort: {
                sortBy: 'invoice_issued_at',
                sortDesc: true,
                items: [
                    {
                        text: 'ID',
                        value: 'id'
                    },
                    {
                        text: 'Invoice Number',
                        value: 'invoice_number'
                    },
                    {
                        text: 'P.O. Number',
                        value: 'purchase_order.purchase_order_number'
                    },
                    {
                        text: 'Vendor Name',
                        value: 'vendor.name'
                    },
                    {
                        text: 'Invoice Date',
                        value: 'invoice_issued_at'
                    },
                    {
                        text: 'Total Cost',
                        value: 'total_cost'
                    }
                ]
            },
            search: {
                input: '',
                sortDesc: true,
                filterBy: 'invoice_number',
                items: [
                    {
                        text: 'Invoice Number',
                        value: 'invoice_number'
                    },
                    {
                        text: 'P.O. Number',
                        value: 'maintenance_purchase_order_number'
                    },
                    {
                        text: 'Vendor Name',
                        value: 'maintenance_vendor'
                    },
                    {
                        text: 'Equipment Name',
                        value: 'equipment_name'
                    },
                    {
                        text: 'Region Name',
                        value: 'region_name'
                    },
                    {
                        text: 'Invoice Date',
                        value: 'invoice_issued_at',
                        operators: [
                            {
                                text: 'After',
                                value: '>'
                            },
                            {
                                text: 'Before',
                                value: '<'
                            },
                            {
                                text: 'On',
                                value: '='
                            }
                        ]
                    },
                    {
                        text: 'Total Cost',
                        value: 'total_cost',
                        operators: [
                            {
                                text: 'Greater Than',
                                value: '>'
                            },
                            {
                                text: 'Less Than',
                                value: '<'
                            },
                            {
                                text: 'Equal To',
                                value: '='
                            }
                        ]
                    }
                ]
            }
        };
    },
    watch: {
        invoiceType() {
            this.localInvoiceType = this.invoiceType;
            console.log("localInvoiceType", this.localInvoiceType);

            let idx = this.search.items.findIndex(itm => itm.value === 'equipment_name');
            
            if (idx !== -1 && this.localInvoiceType.value === 'supplies') {
                this.search.items.splice(idx, 1);
            } else if (idx === -1 && (this.localInvoiceType.value === 'truck' || this.localInvoiceType.value === 'trailer')) {
                this.search.items.splice(3, 0, {
                    text: 'Equipment Name',
                    value: 'equipment_name'
                });
            }
            console.log(idx, this.search.items);
        },
        sort: {
            handler() {
                this.$emit('update:sort', this.sort);
            },
            deep: true
        }
        /*'search.input': {
            handler() {
                this.$emit('update:search', this.search);
            },
            deep: true
        }*/
    },
    methods: {
        emitSearch() {
            this.$emit('update:search', this.search);
            console.log('Emitting search: ', this.search);
        },
        emitSort() {
            this.$emit('update:sort', this.sort);
            console.log('Emitting sort: ', this.sort);
        },
        emitInvoiceType() {
            this.$emit('update:invoiceType', this.localInvoiceType);
            console.log('Emitting invoiceType: ', this.localInvoiceType);
        },
        toggleSortDirection() {
            this.sort.sortDesc = !this.sort.sortDesc;
        }
    }
};
</script>
